import React, { useEffect, useState } from "react";
import { IconContext } from "react-icons";
import { FaApple, FaFacebook, FaGoogle, FaChevronRight } from "react-icons/fa";
import { IoCaretBack } from "react-icons/io5";
import { BiArrowBack } from "react-icons/bi";
import { useLocation, useNavigate } from "react-router-dom";
// import colors from "../config/colors";
// import { useDispatch, useSelector } from "react-redux";
// import apiClient from "../api/apiClient";
// import { login } from "../redux/counterSlice";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Input from "@mui/material/Input";
import FilledInput from "@mui/material/FilledInput";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { AdminButton } from "../../components/mui";
export default () => {
  let loginState = {
    email: "",
    password: "",
  };

  const navigate = useNavigate();
  //   const [type, setType] = useState("");
  const [showPassword, setShowPassword] = useState(true);
  const [loginData, setLoginData] = useState(loginState);
  const [message, setMessage] = useState({ text: "", color: "" });
  const handleChange = (key, value) => {
    setLoginData({ ...loginData, [key]: value });
  };
  useEffect(() => {
    document.title = "RollingAdz: Add Users" || "Default Title";
  }, []);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  //   function resetErrors() {
  //     setMessage({ text: "", color: "" });
  //   }
  //   const dispatch = useDispatch();
  //   const { isLoggedIn, userType } = useSelector((state) => state.auth);

  const handleSubmit = async (e) => {
    e.preventDefault();
    // if (loginData.password.length < 6)
    //   return setMessage({
    //     text: "Password should be atleast 6 characters",
    //     color: "danger",
    //   });
    // console.log(loginData);
    // const result = await apiClient.post("/user/signin", loginData);
    // if (result.ok && result.data?.token) {
    //   const authToken = result.data?.token;
    //   console.log(authToken);
    //   apiClient.setHeader("Authorization", `Bearer ${authToken}`);
    //   const userInfo = await apiClient.get("/user/user-info");
    //   console.log(userInfo);
    //   dispatch(login({ token: authToken, userType: userInfo.data.role }));
    //   handleNavigate(userInfo.data.role);
    // }
  };
  function handleNavigate(role) {
    // if (role == "IN") navigate("/installeraccount");
    // else if (role == "PH") navigate("/photograperaccount");
    // else if (role == "AC") navigate("/advertiser-account");
    // else if (role == "VO") navigate("/vehicleowneraccount");
    // else if (role == 5) navigate("/driver-search-result");
  }
const location=useLocation()
const name = location.state

  return (
    <div className="">
      {/* Signup button popup */}
      <div className=" d-flex justify-content-center align-items-center ">
        <div className="   rounded-3 col-md-6">
          <div onClick={() => navigate(-1)}>
            <BiArrowBack size={35} color={"#1976d2"} />
          </div>
          <form onSubmit={handleSubmit}>
            {/* <h1 className="display-1 text-secondary h1 text-center"><i className="bi bi-truck" /></h1> */}
            <div className=" login-form col-md-10 mx-auto">
              {/* <div className="icon d-flex align-items-center justify-content-around blue-clr pb-4">
                <FaGoogle size={45} />
                <FaFacebook size={45} />
                <FaApple size={45} />
              </div> */}
              <Grid container spacing={3} py={2}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    id="outlined-basic"
                    label="Email"
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel htmlFor="outlined-adornment-password">
                      Password
                    </InputLabel>
                    <OutlinedInput
                      id="outlined-adornment-password"
                      type={showPassword ? "text" : "password"}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      }
                      label="Password"
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      Select User
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      // value={'Photographer'}
                      label="Select User"
                      // defaultValue={"installer"}
                      // onChange={handleChange}
                    >
                      {/* <MenuItem value={10}>Installer</MenuItem>
                      <MenuItem value={20}>Photographer</MenuItem>
                      <MenuItem value={30}>Vehicle Owner</MenuItem>
                      <MenuItem value={40}>Advertiser</MenuItem>
                      <MenuItem value={50}>Designer</MenuItem> */}
                      <MenuItem value={10}>Admin</MenuItem>
                      <MenuItem value={20}>Super Admin</MenuItem>
                      <MenuItem value={30}>Viewer</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} className="d-flex justify-content-center">
                  <AdminButton name={`  ${name?"Update User":"Add User" } `} size="large" />
                </Grid>
              </Grid>

              <div></div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
